import { createPortal } from "react-dom";

import { usePopupStore } from "@/store/common/usePopupStore";

import ConfirmPop from "./ConfirmPop";
import LoadingPop from "./LoadingPop";

const Popup = () => {
    const { confirmPop, loadingPop, loadingPopConsole } = usePopupStore();

    return createPortal(
        <>
            {/* 알림 팝업 */}
            {confirmPop && <ConfirmPop />}

            {/* 로딩 팝업 */}
            {loadingPop && <LoadingPop console={loadingPopConsole} />}
        </>,
        document.getElementById("modal-root")!,
    );
};

export default Popup;
